/** Shared mobile-first tokens for public booking. */
export const BOOKING_BRAND = {
  primary: '#1565c0',
  primaryDark: '#0d47a1',
  bg: '#f0f4f8',
  headerGradient: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 55%, #42a5f5 100%)',
};

export const SAFE_BOTTOM = 'max(12px, env(safe-area-inset-bottom, 0px))';
export const SAFE_TOP = 'max(0px, env(safe-area-inset-top, 0px))';

/** 44px minimum touch target (Apple HIG). */
export const touchIconBtn = {
  width: 44,
  height: 44,
  borderRadius: 2,
};

/** Prevents iOS zoom on focus — use 16px+ font on inputs. */
export const mobileInputProps = {
  style: { fontSize: 16 },
};

export function scrollBookingTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
